import { ConfirmationMessageType } from '../../services/commands/UserInteractor';
import { DatasetRelated } from '../dataset/DatasetRelated';

export enum ConfirmationType {
  CATALOGS = 'Catalogs',
  HIERARCHY = 'Hierarchy',
  DATASET = 'Dataset',
}
export interface ConfirmationCommand {
  readonly command: string;
  readonly args: any;
  readonly hook: boolean;
}

interface BaseConfirmationEntity {
  readonly messageType: ConfirmationMessageType;
  readonly action: ConfirmationCommand;
  readonly shortMessage?: string;
  readonly longMessage?: string;
  readonly icon?: string;
}

interface CatalogsConfirmationEntity extends BaseConfirmationEntity {
  readonly type: ConfirmationType.CATALOGS;
}

interface HierarchyConfirmationEntity extends BaseConfirmationEntity {
  readonly type: ConfirmationType.HIERARCHY;
}

interface DatasetConfirmationEntity
  extends BaseConfirmationEntity, DatasetRelated {
  readonly type: ConfirmationType.DATASET;
}

export type ConfirmationEntity<T extends ConfirmationType = ConfirmationType> =
  T extends ConfirmationType.CATALOGS
    ? CatalogsConfirmationEntity
    : T extends ConfirmationType.HIERARCHY
      ? HierarchyConfirmationEntity
      : DatasetConfirmationEntity;
